export default __webpack_public_path__ + "static/media/mission-assistance.255b245f.png";